var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSimilarwebTrafficData = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M9.428 6.963c-.117.41-.24.743-.306 1.087-.227 1.16.193 2.137.95 2.974.416.46.917.842 1.377 1.262s.952.81 1.364 1.271c.638.714.726 1.555.338 2.422-.38.846-1.08 1.265-1.983 1.336-2.026.158-3.83-1.057-4.603-3.082a5.826 5.826 0 0 1 2.473-7.066c.108-.064.222-.117.39-.204",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M14.528 17.384c.207-.558.49-1.143.64-1.76.29-1.2-.117-2.248-.93-3.117-.536-.573-1.175-1.049-1.75-1.587-.415-.39-.843-.78-1.192-1.227-.49-.628-.501-1.347-.14-2.047.35-.681.942-1.006 1.704-1.03 1.492-.045 2.594.715 3.527 1.763 2.538 2.851 1.546 7.46-1.859 9.005",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSimilarwebTrafficData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/similarweb-traffic-data.77f0b397.svg";